<template>
  <div id="app" class="dodel-calculator">
    <cart-header></cart-header>
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'App',
  components: {
  },
  mounted(){
    this.load()
  },
  data(){
    return {
      menu: [],
    }
  }
  ,
  methods:{ 
    load(){
      axios.get('/wp-admin/admin-ajax.php?action=dodel_nutri').then((response=>{
        this.menu = response.data
        this.menu = this.menu.map(category=>{
          category.children = category.children.map(menu_item=>{
            menu_item.include = true
            menu_item.customize = false
            menu_item.nutritions = menu_item.nutritions.map(nutrition=>{
              nutrition.include = true
              return nutrition
            })
            return menu_item
          })
          return category
        })
        this.$store.commit('update', this.menu)
        this.$store.commit('language', window.dodel_translations)
      }))
    }
  }
}
</script>

<style>
  .dodel-calculator{
    color: #333;
    margin: 40px 0;
  }
  .dodel-calculator a{
    color: #006bae;
  }
  .dodel-menu-items{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .dodel-menu-item{
    flex-basis: 48%;
    margin-bottom: 20px;
  }
  .dodel-menu-item-full{
    flex-basis: 100%;
  }
  .dodel-page-header{
    display: flex;
    flex-direction: column;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .dodel-page-header svg{
    height: 10px;
    fill: #006bae;
  }
  .dodel-page-header a{
    align-self: flex-start;
    font-size: 14px;
  }
  .dodel-page-header .dodel-screen-title{
    align-self: center;
    margin-top: -1.75em;
    font-weight: bold;
  }

  @media screen and (max-width: 768px){
    .dodel-menu-items{
      display: block;
    }
    .dodel-menu-item{
      width: 100%;
    }
  }
</style>
